import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=4ee98411&scoped=true"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDashboard.vue?vue&type=style&index=0&id=4ee98411&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee98411",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
